import React, { useState, useEffect, useRef } from 'react';
import './NavigationBar.css';
import ChevronDown from '../icons/ChevronDown';
import Language from '../icons/Language';
import ArrowRight from '../icons/ArrowRight';
import NavPlatform from './NavPlatform';
import NavCompany from './NavCompany';
import NavResources from './NavResources';
import NavLanguage from './NavLanguage';
import MobileMenu from './MobileMenu';
import { useTranslation } from 'react-i18next';
import useLanguagePrefix from '../LanguagePrefix';
import NavSolutions from './NavSolutions';
import NavAi from './NavAi';

function NavigationBar({ onToggleMobileMenu }) {
    const [openMenu, setOpenMenu] = useState('');
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState("EN");
    const platformBtnRef = useRef(null);
    const companyBtnRef = useRef(null);
    const resourcesBtnRef = useRef(null);
    const solutionsBtnRef = useRef(null);
    const languageBtnRef = useRef(null);
    const prostayAiBtnRef = useRef(null);

    const { i18n, t } = useTranslation();
    const langPrefix = useLanguagePrefix();

    useEffect(() => {
        // const languageMap = { en: "EN", ro: "RO", es: "ES", de: "DE" };
        const languageMap = { en: "EN", es: "ES" };
        setCurrentLanguage(languageMap[i18n.language] || "EN");
    }, [i18n.language]);

    return (
        <div className='navigation-bar'>
            <a href={langPrefix + "/" || "/"}><img style={{ cursor: "pointer" }} src="/images/prostay-logo-dark.svg" alt="Prostay Logo" className='logo' /></a>
            <div className='nav-menu d-flex gap-3 gap-md-5'>
                <div className='menu d-flex align-items-center gap-2 gap-md-3 gap-lg-4'>
                    <a href={`${langPrefix}/ai/`}ref={prostayAiBtnRef} className='text-btn-small d-flex gap-2 align-items-center' onMouseEnter={() => setOpenMenu("ai")} onMouseLeave={() => setOpenMenu("")} onClick={() => { if (openMenu != "ai") setOpenMenu("ai"); else setOpenMenu("") }} style={{ position: 'relative', height: '100%', textDecoration: 'none' }}>
                        {t('Prostay AI')}
                        <img src='/images/prostay-ai-logo.svg' />
                        <div
                            className={`nav-platform-container ${openMenu == "ai" ? "visible" : ""}`}>
                            <NavAi onClose={() => setOpenMenu("")} buttonRef={prostayAiBtnRef} />
                        </div>
                    </a>
                    <button ref={platformBtnRef} className='text-btn-small d-flex gap-2 align-items-center' onMouseEnter={() => setOpenMenu("platform")} onMouseLeave={() => setOpenMenu("")} onClick={() => { if (openMenu != "platform") setOpenMenu("platform"); else setOpenMenu("") }} style={{ position: 'relative', height: '100%' }}>
                        {t('Platform')}
                        <ChevronDown />
                        <div
                            className={`nav-platform-container ${openMenu == "platform" ? "visible" : ""}`}>
                            <NavPlatform onClose={() => setOpenMenu("")} buttonRef={platformBtnRef} />
                        </div>
                    </button>
                    <button ref={solutionsBtnRef} className='text-btn-small d-flex gap-2 align-items-center' onMouseEnter={() => setOpenMenu("solutions")} onMouseLeave={() => setOpenMenu("")} onClick={() => { if (openMenu != "solutions") setOpenMenu("solutions"); else setOpenMenu("") }} style={{ position: 'relative', height: '100%' }}>
                        {t('Solutions')}
                        <ChevronDown />
                        <div
                            className={`nav-resources-container ${openMenu == "solutions" ? "visible" : ""}`}>
                            <NavSolutions onClose={() => setOpenMenu("")} buttonRef={solutionsBtnRef} />
                        </div>
                    </button>
                    <a href={`${langPrefix}/pricing/`} style={{ textDecoration: 'none' }}><button className='text-btn-small d-flex gap-2 align-items-center'>
                        {t('Pricing')}
                    </button></a>
                    <button ref={resourcesBtnRef} className='text-btn-small d-flex gap-2 align-items-center' onMouseEnter={() => setOpenMenu("resources")} onMouseLeave={() => setOpenMenu("")} onClick={() => { if (openMenu != "resources") setOpenMenu("resources"); else setOpenMenu("") }} style={{ position: 'relative', height: '100%' }}>
                        {t('Resources')}
                        <ChevronDown />
                        <div
                            className={`nav-resources-container ${openMenu == "resources" ? "visible" : ""}`}>
                            <NavResources onClose={() => setOpenMenu("")} buttonRef={resourcesBtnRef} />
                        </div>
                    </button>
                    <button ref={companyBtnRef} className='text-btn-small d-flex gap-2 align-items-center' onMouseEnter={() => setOpenMenu("company")} onMouseLeave={() => setOpenMenu("")} onClick={() => { if (openMenu != "company") setOpenMenu("company"); else setOpenMenu("") }} style={{ position: 'relative', height: '100%' }}>
                        {t('Company')}
                        <ChevronDown />
                        <div
                            className={`nav-company-container ${openMenu == "company" ? "visible" : ""}`}>
                            <NavCompany onClose={() => setOpenMenu("")} buttonRef={companyBtnRef} />
                        </div>
                    </button>
                    <button ref={languageBtnRef} className='text-btn-small d-flex gap-2 align-items-center' onMouseEnter={() => setOpenMenu("language")} onMouseLeave={() => setOpenMenu("")} onClick={() => { if (openMenu != "language") setOpenMenu("language"); else setOpenMenu("") }} style={{ position: 'relative', height: '100%' }}>
                        <Language />
                        {currentLanguage}
                        <ChevronDown />
                        <div
                            className={`nav-language-container ${openMenu === "language" ? "visible" : ""}`}>
                            <NavLanguage onClose={() => setOpenMenu("")} buttonRef={languageBtnRef} />
                        </div>
                    </button>
                </div>
                <div className='d-flex align-items-center gap-2 gap-md-3'>
                    <button className='text-btn-small d-flex gap-2 align-items-center'
                        onClick={() => {
                            const link = 'https://app.prostay.com';
                            const a = document.createElement('a');
                            a.href = link;
                            a.target = '_blank';
                            a.rel = 'noopener noreferrer';
                            a.click();
                        }}>
                        {t('Login')}
                    </button>
                    <a href={`${langPrefix}/request-demo/`} style={{ textDecoration: 'none' }}><button className='light-blue-filled-btn-small d-flex gap-2 align-items-center'>
                        {t('Request Demo')}
                        <ArrowRight />
                    </button></a>
                </div>
            </div>
            <button onClick={() => { setMobileMenuOpen(!mobileMenuOpen); onToggleMobileMenu(); }} className='mobile-menu-btn' style={{ height: 38, width: 38, backgroundColor: '#1643E0', borderRadius: 8, alignItems: 'center', justifyContent: 'center', border: 'none', padding: 0 }}>
                {
                    mobileMenuOpen ?
                        <svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 9L9 1M1 1L9 9" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        :
                        <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.8999 4C2.8999 3.92044 2.93151 3.84413 2.98777 3.78787C3.04403 3.73161 3.12034 3.7 3.1999 3.7H12.7999C12.8795 3.7 12.9558 3.73161 13.012 3.78787C13.0683 3.84413 13.0999 3.92043 13.0999 4C13.0999 4.07957 13.0683 4.15587 13.012 4.21213C12.9558 4.26839 12.8795 4.3 12.7999 4.3H3.1999C3.12034 4.3 3.04403 4.26839 2.98777 4.21213C2.93151 4.15587 2.8999 4.07957 2.8999 4ZM2.8999 8C2.8999 7.92044 2.93151 7.84413 2.98777 7.78787C3.04403 7.73161 3.12034 7.7 3.1999 7.7H12.7999C12.8795 7.7 12.9558 7.73161 13.012 7.78787C13.0683 7.84413 13.0999 7.92043 13.0999 8C13.0999 8.07957 13.0683 8.15587 13.012 8.21213C12.9558 8.26839 12.8795 8.3 12.7999 8.3H3.1999C3.12034 8.3 3.04403 8.26839 2.98777 8.21213C2.93151 8.15587 2.8999 8.07957 2.8999 8ZM7.6999 12C7.6999 11.9204 7.73151 11.8441 7.78777 11.7879C7.84403 11.7316 7.92034 11.7 7.9999 11.7H12.7999C12.8795 11.7 12.9558 11.7316 13.012 11.7879C13.0683 11.8441 13.0999 11.9204 13.0999 12C13.0999 12.0796 13.0683 12.1559 13.012 12.2121C12.9558 12.2684 12.8795 12.3 12.7999 12.3H7.9999C7.92034 12.3 7.84403 12.2684 7.78777 12.2121C7.73151 12.1559 7.6999 12.0796 7.6999 12Z" fill="#18181B" stroke="white" />
                        </svg>
                }
            </button>
            <MobileMenu isOpen={mobileMenuOpen} onClose={() => { setMobileMenuOpen(false); onToggleMobileMenu(); }} />
        </div>
    );
}

export default NavigationBar;
